import {Api, apiUrls, SortingAndFilteringParams} from "../../helpers/api";
import http from "../../common/services/httpService";
import {AxiosResponse} from "axios";
import {PageableModel} from "../../common/models/table";
import {
    ModifyUserInManagementModel,
    NewUserInManagementModel,
    UserInManagementModel
} from "../models/user";
import {HttpErrorModel} from "../../common/models/httpError";

export class AdministrationService {
    private static baseUrl = apiUrls.administration.users;

    public static async getAll(sortingAndFilteringParams: SortingAndFilteringParams): Promise<AxiosResponse<PageableModel<UserInManagementModel>>> {
        const url = Api.addSortingAndFilteringParams(Api.getUrl(this.baseUrl), sortingAndFilteringParams);
        return await http.get<PageableModel<UserInManagementModel>>(url);
    }

    public static async enableOrDisableUser(id: string, enable: boolean): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.patch(`${Api.getUrl(this.baseUrl)}/${id}/enable`, {enable});
    }

    public static async addUser(data: NewUserInManagementModel): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.post(`${Api.getUrl(this.baseUrl)}`, data);
    }

    public static async getUser(id: string): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.get(`${Api.getUrl(this.baseUrl)}/${id}`);
    }

    public static async modifyUser(id: string, data: ModifyUserInManagementModel): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.patch(`${Api.getUrl(this.baseUrl)}/${id}`, data);
    }

    public static async resetUserPassword(id: string): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.patch(`${Api.getUrl(this.baseUrl)}/${id}/password/reset`);
    }

    public static async temporaryUserPassword(id: string, newPassword: string, confirmPassword: string): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.patch(`${Api.getUrl(this.baseUrl)}/${id}/password/temporary`, {newPassword, confirmPassword});
    }

    public static async removeUser(id: string): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.delete(`${Api.getUrl(this.baseUrl)}/${id}`);
    }
}
